import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import { Fraunces, Hanken_Grotesk } from 'next/font/google'

import { CookieConsent } from '@/components/generals/cookie-consent'

const fontHeading = Fraunces({
    variable: '--font-heading',
    subsets: ['latin'],
    display: 'swap'
})

const fontSans = Hanken_Grotesk({
    variable: '--font-sans',
    subsets: ['latin'],
    display: 'swap'
})

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className={`${fontSans.variable} ${fontHeading.variable} font-sans antialiased`}>
            <Component {...pageProps} />
            <CookieConsent />
        </div>
    )
}

export default App
